import { CoverSection } from './view';
export default CoverSection;
